export const READ_MORE = 'Read More'
